import { render, staticRenderFns } from "./SearchGenreList.vue?vue&type=template&id=83e9bb5c&"
import script from "./SearchGenreList.vue?vue&type=script&lang=js&"
export * from "./SearchGenreList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports